// extracted by mini-css-extract-plugin
module.exports = {"lineContent":"ArticleMetaData_lineContent__Ejz30","articleInfoItems":"ArticleMetaData_articleInfoItems__1tp1Q"};